import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"4\" cy=\"12\" r=\"3\"><animate begin=\"0\" attributeName=\"r\" dur=\"0.9s\" values=\"3;.4;3\" repeatCount=\"indefinite\"></animate></circle><circle cx=\"12\" cy=\"12\" r=\"3\"><animate begin=\"0.15s\" attributeName=\"r\" dur=\"0.9s\" values=\"3;.4;3\" repeatCount=\"indefinite\"></animate></circle><circle cx=\"20\" cy=\"12\" r=\"3\"><animate begin=\"0.3s\" attributeName=\"r\" dur=\"0.9s\" values=\"3;.4;3\" repeatCount=\"indefinite\"></animate></circle>", 3)
  ]))]))
}
export default { render: render }